import { useLoctool } from "@bigfish/react-loctool";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";

export function RouteAnnouncer() {
    const router = useRouter();
    const [message, setMessage] = useState("");
    const Intl = useLoctool();

    useEffect(() => {
        const handleStart = () => {
            setMessage(Intl.formatMessage({ id: "components.routeAnnouncer.loading" }));
        };

        const handleComplete = () => {
            setTimeout(() => {
                const main = document.querySelector("main");
                const heading = main?.querySelector("h1, h2, h3, h4, h5") as HTMLElement | null;

                if (heading) {
                    heading.setAttribute("tabindex", "-1");
                    heading.focus();
                    setMessage(heading.innerText || Intl.formatMessage({ id: "components.routeAnnouncer.loadedSuccessfully" }));
                } else {
                    setMessage(Intl.formatMessage({ id: "components.routeAnnouncer.loadedSuccessfully" }));
                }
            }, 0);
        };

        router.events.on("routeChangeStart", handleStart);
        router.events.on("routeChangeComplete", handleComplete);

        return () => {
            router.events.off("routeChangeStart", handleStart);
            router.events.off("routeChangeComplete", handleComplete);
        };
    }, [router]);

    return (
        <div
            aria-live="polite"
            aria-atomic="true"
            style={{
                position: "absolute",
                left: "-9999px",
                height: "1px",
                width: "1px",
                overflow: "hidden",
            }}
        >
            {message}
        </div>
    );
}
